import { ChallengesForm } from '../component/challengeForm/ChallengesForm';

const Challenges = () => {
  return <ChallengesForm />;
};

export default Challenges;
